'use client';

import * as React from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import { cn } from '~/util';

const RadioGroup = React.forwardRef<
    React.ElementRef<typeof RadioGroupPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
     
>(({ className, ...props }, ref) => (
    <RadioGroupPrimitive.Root
        ref={ref}
        className={cn('flex flex-col gap-2', className)}
         
        aria-labelledby={props['aria-labelledby']}
        {...props}
    />
));
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;
const RadioGroupItem = React.forwardRef<
    React.ElementRef<typeof RadioGroupPrimitive.Item>,
    React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & {
        label?: string;
    }
     
>(({ className, id, label, ...props }, ref) => (
    <div className="flex items-center space-x-2">
        <RadioGroupPrimitive.Item
            ref={ref}
            id={id}
            className={cn(
                'relative flex h-5 w-5 items-center justify-center rounded-full border border-secondary-foreground bg-background focus:outline-none focus:ring-primary focus:ring-1 disabled:cursor-not-allowed disabled:opacity-50',
                className,
            )}
            {...props}
        >
            <RadioGroupPrimitive.Indicator className="absolute inset-0 flex items-center justify-center rounded-full">
                <div className="h-2.5 w-2.5 rounded-full bg-primary" />
            </RadioGroupPrimitive.Indicator>
        </RadioGroupPrimitive.Item>
        {label && (
            <label htmlFor={id} className="text-sm">
                {label}
            </label>
        )}
    </div>
));
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

const RadioGroupDescription = React.forwardRef<
    React.ElementRef<'p'>,
    React.ComponentPropsWithoutRef<'p'>
     
>(({ className, ...props }, ref) => (
    <p
        ref={ref}
        className={cn('text-sm text-muted-foreground', className)}
        {...props}
    />
));
RadioGroupDescription.displayName = 'RadioGroupDescription';

export { RadioGroup, RadioGroupItem, RadioGroupDescription };
